"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetSupportState = exports.getCustomerDetails = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const typesConstants_1 = require("../../constants/typesConstants");
const network_1 = require("../../utils/network");
const utils_1 = require("../../utils/utils");
const supportConstants_1 = __importDefault(require("./supportConstants"));
const constants_1 = require("../../constants/constants");
exports.getCustomerDetails = toolkit_1.createAsyncThunk('support/user', async ({ email, phone_number_bvn, phone_number }, { getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const queryParams = utils_1.encodeUrlParams({
            ...(email && { email }),
            ...(phone_number && { phone_number }),
            ...(phone_number_bvn && { phone_number_bvn }),
        });
        const urlPath = `${supportConstants_1.default}?${queryParams}`;
        return await network_1.get(urlPath, auth.token)
            .then(network_1.checkHttpStatus)
            .then(network_1.parseJSON);
    }
    catch (err) {
        return network_1.handleDefaultError(err, rejectWithValue);
    }
});
const initialState = {
    customer: null,
    status: typesConstants_1.PENDING_STATUS,
};
const supportSlice = toolkit_1.createSlice({
    name: 'support',
    initialState,
    reducers: {
        resetSupportState() {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(exports.getCustomerDetails.pending, (state) => ({
            ...state,
            loadingStatus: typesConstants_1.PENDING_STATUS,
        }))
            .addCase(exports.getCustomerDetails.fulfilled, (state, { payload }) => ({
            ...state,
            loadingStatus: typesConstants_1.SUCCEEDED_STATUS,
            customer: payload,
        }))
            .addCase(exports.getCustomerDetails.rejected, (state, { payload }) => {
            return {
                ...state,
                customer: null,
                loadingStatus: typesConstants_1.FAILED_STATUS,
                errorMessage: payload.message === network_1.message404
                    ? constants_1.NOT_FOUND
                    : utils_1.convertObjToPlainString(payload.errorObject || {}),
            };
        });
    },
});
exports.resetSupportState = supportSlice.actions.resetSupportState;
exports.default = supportSlice.reducer;
